<template>
  <el-container class="login-container">

    <div class="login-content">
      <div class="ctent-left">
        <!-- <img src="../assets/img/logo.jpg" alt="" /> -->
      </div>
      <div class="ctent-right">
        <div class="bef-login">
          <div class="right-title" v-if="!isRegister">
            <span>登录</span>
            <span class="right-text">SIGN IN</span>
          </div>
          <div class="right-title" v-else>
            <span>注册</span>
            <span class="right-text">SIGN UP</span>
          </div>
          <el-form :model="loginForm" ref="loginForm" label-width="60px" v-show="!isRegister" :rules="loginRules">
            <el-form-item prop="account" style="position: relative" class="form-input">
              <el-input type="text" placeholder="请输入账号" clearable v-model="loginForm.account"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="form-input">
              <el-input clearable type="password" placeholder="请输入密码" v-model="loginForm.password" v-on:keyup.enter.native="login" ref="password"></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button type="primary" class="sing-btn" @click="login">登录</el-button>
              <el-button type="primary" class="sing-btn" @click="getInfo">注册</el-button>
            </el-form-item>
          </el-form>
          <el-form style="padding-top: 30px;" :model="registerForm" ref="registerForm" :rules="rules" label-width="60px" v-show="isRegister">
            <el-form-item prop="SchoolId" style="position: relative" class="form-input">
              <el-select v-model="registerForm.SchoolId" placeholder="请选择学校" style="width: 100%;">
                <el-option v-for="item in schoolL" :key="item.SchoolId" :label="item.SchoolName" :value="item.SchoolId" />
              </el-select>
            </el-form-item>
            <el-form-item prop="Area" style="position: relative" class="form-input">
              <el-cascader placeholder="请选择地区" v-model="registerForm.Area" :options="adressL" style="width: 100%;" @change="handleChange" />
            </el-form-item>
            <el-form-item prop="Name" style="position: relative" class="form-input">
              <el-input type="text" placeholder="请输入姓名" clearable v-model="registerForm.Name"></el-input>
            </el-form-item>
            <el-form-item prop="Account" style="position: relative" class="form-input">
              <el-input type="text" placeholder="请输入手机号" clearable v-model="registerForm.Account"></el-input>
            </el-form-item>
            <el-form-item prop="Password" class="form-input">
              <el-input clearable type="password" placeholder="请输入密码" v-model="registerForm.Password" v-on:keyup.enter.native="register" ref="password"></el-input>
            </el-form-item>
            <el-form-item prop="repeatpassword" class="form-input">
              <el-input clearable type="password" placeholder="请确认密码" v-model="registerForm.repeatpassword" v-on:keyup.enter.native="register" ref="password"></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button type="primary" class="sing-btn" @click="register">注册</el-button>
              <el-button type="primary" class="sing-btn" @click="isRegister = false">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    //密码与重复密码不一致，一定写在data里但不是return里
    let repeatValidate = (rule, value, callback) => {
      if (value !== this.registerForm.Password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    //正则校验主要是这部分：/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,16}$
    //其中特殊字符包括：._~!@#$^&*  （比较常见）
    // let newValValidate = (rule, value, callback) => {
    //   if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,16}$/g.test(value)) {
    //     callback()
    //   } else {
    //     callback(new Error('请输入包含英文字母大小写、数字和特殊符号的 8-16 位组合'))
    //   }
    // }
    let phoneValidate = (rule, value, callback) => {
      if (/^1[3-9]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      schoolL: [],
      adressL: [],
      isRegister: false,
      isLogin: true,
      loginForm: {
        account: '',
        password: '',
        isAdmin: false
      },
      registerForm: {
        SchoolId:'',
        Area:'',
        Account: '',
        Name: '',
        Password: '',
        repeatpassword: '',
        isAdmin: false
      },
      loginRules: {
        account: [
          { required: true, message: '账号是你注册的手机号', trigger: 'blur' },],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            min: 3,
            max: 11,
            message: '长度应在 3到 11 个字符',
            trigger: 'blur'
          },],
      },
      rules: {
        SchoolId: [{ required: true, message: '请选择学校', trigger: 'blur' }],
        Area: [{ required: true, message: '请选择地区', trigger: 'blur' }],
        Account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: phoneValidate, trigger: 'blur' }],
        Name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        Password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            min: 3,
            max: 11,
            message: '长度应在 3到 11 个字符',
            trigger: 'blur'
          },
        ],
        repeatpassword: [
          { required: true, message: '请再输入一遍密码', trigger: 'blur' },
          { validator: repeatValidate, trigger: 'blur' }
        ]
      }
    };
  },
  components: {},
  mounted() {

  },
  methods: {
    getInfo() {
      this.isRegister = true
      this.$api.HJGetAllAddress().then(res => {
        if (res.Success) {
          this.adressL = this.convertToCascaderData(res.Data);
          console.log(this.adressL)
        } else this.$message.error(res.Msg)
      })
      this.$api.HJGetAllSchool().then(res => {
        if (res.Success) {
          this.schoolL = res.Data
        } else this.$message.error(res.Msg)
      })
    },
    handleChange(data) {
      let pIndex = this.adressL.findIndex(item => item.value == data[0])
      this.registerForm.Province = this.adressL[pIndex].label
      let cIndex = this.adressL[pIndex].children.findIndex(item => item.value == data[1])
      this.registerForm.City = this.adressL[pIndex].children[cIndex].label
      let dIndex = this.adressL[pIndex].children[cIndex].children.findIndex(item => item.value == data[2])
      this.registerForm.District = this.adressL[pIndex].children[cIndex].children[dIndex].label
      console.log(this.registerForm)
    },
    convertToCascaderData(address, level = 1) {
      if (!address) {
        return [];
      }

      return address.map(item => {
        const { Id, Code, FatherCode, Name, Level, LevelName, AddressList } = item;
        const cascaderItem = {
          value: Id,
          label: Name,
          code: Code,
          fatherCode: FatherCode,
          level: Level,
          levelName: LevelName
        };
        if (AddressList && AddressList.length > 0) {
          cascaderItem.children = this.convertToCascaderData(AddressList, level + 1);
        }
        return cascaderItem;
      });
    },
    login() {
      this.$api.HJAccountLogin(this.loginForm).then(res => {
        if (res.Success) {
          this.$message.success('登录成功')
          sessionStorage.setItem('userInfo', JSON.stringify(res.Data));
          sessionStorage.setItem('token', res.Data.Token);
          //跳转
          // this.$router.push('/ExamList');
          this.$router.push(this.$route.query.redirect || '/')
        } else this.$message.error(res.Msg)
      })
    },
    register() {
      this.$refs.registerForm.validate((valid, mes) => {
        console.log(valid, mes)
        if (valid) {
          this.$api.HJAccountRegister(this.registerForm).then(res => {
            if (res.Success) {
              this.$message.success('注册成功')
              this.loginForm.account = this.registerForm.Account
              this.isLogin = true
            } else this.$message.error(res.Msg)
          })
        }
      })

    },
  },
};
</script>


<style lang="scss" scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../assets/img/login-bg.png) center no-repeat;
  background-size: cover;
  overflow: hidden;
}

.login-content {
  width: 980px;
  height: 600px;
  display: flex;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  box-shadow: 2px 3px 12px #040404b8;
}

.ctent-left {
  background: url("../assets/img/logo.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: 580px;

  // img {
  //   width: 100%;
  // }
}

.ctent-right {
  width: 400px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 70px 80px;
  border-left: 3px solid #ebf5ff;
}

.right-title {
  color: #a6c64e;
  font-size: 30px;

  .right-text {
    color: #b4b4b4;
    font-size: 16px;
  }
}

::v-deep.form-input {
  .el-form-item__content {
    margin-left: 0 !important;

    .el-input__inner {
      border: none;
      border-bottom: 1px solid #b4b4b4;
      border-radius: 0;

      &:focus {
        border-color: #0a1f8f;
        color: #000;
      }
    }
  }
}

.el-form {
  padding-top: 70px;
  text-align: center;
}

.btn {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    display: flex;
    justify-content: space-between;
  }
}

.sing-btn {
  margin: 20px 0 0;
  width: 100px;
  height: 38px;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

// #b4b4b4;
.logining {
  padding: 90px 40px 0 60px;

  .login-wait {
    width: 136px;
    height: 136px;
    border: 2px solid #a6c64e;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .success {
    background-color: #a6c64e;
  }

  .wait-img {
    width: 70px;
    -webkit-transform: rotate(360deg);
    animation: rotation 3s linear infinite;
    -moz-animation: rotation 3s linear infinite;
    -webkit-animation: rotation 3s linear infinite;
    -o-animation: rotation 3s linear infinite;
  }

  .login-text {
    padding-top: 88px;
    text-align: center;
    color: #0a1f8f;
    font-size: 16px;
  }
}

// linear-gradient
</style>


